import { useEffect, useReducer } from 'react'
import { isLargeScreen } from '../utils/mediaQuery'

const defaultState = {
  maximized: false,
}

const reducer = (state, newState) => ({ ...state, ...newState })

function useSidebarNavigation(options = {}){
  const { forceMaximized, minimized } = options || {}

  const [state, setState] = useReducer(reducer, defaultState)
  const { maximized } = state

  const largeScreen = isLargeScreen()

  useEffect(() => {
    if (!minimized && (forceMaximized || largeScreen)){
      setState({ maximized: true })
    }

    if (minimized && !forceMaximized){
      setState({ maximized: false })
    }
  }, [forceMaximized, minimized, largeScreen])

  const toggleDisabled = forceMaximized || (largeScreen && !minimized)

  return {
    largeScreen,
    maximized,
    setMaximized: !toggleDisabled ? isMaximized => setState({ maximized: isMaximized }) : null,
  }
}

export default useSidebarNavigation
